module.exports = __webpack_public_path__ + "658be600ce8bf1db7285976fb13ba755.woff2";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/fonts/Avenir-Black.woff2
// module id = 651
// module chunks = 0